<template>
	<div>
    <div class="change-password-container">
      <form>
        <div class="form-control-container">
          <label>Current password</label>
          <input v-model="credentials.currentPassword" type="password" @keyup.enter="changePassword">
        </div>
        <div class="form-control-container">
          <label>New password</label>
          <input v-model="credentials.newPassword" type="password" v-on:keyup="validatePassword()" @keyup.enter="changePassword">
          <div v-if="credentials.newPassword && !newPasswordValid" class="validation-message error">{{passwordValidationInstructions}}</div>
        </div>
        <div class="form-control-container">
          <label>Confirm new password</label>
          <input v-model="credentials.newPasswordConfirm" type="password" @keyup.enter="changePassword">
          <div v-if="credentials.newPasswordConfirm && credentials.newPasswordConfirm.length >= credentials.newPassword.length && credentials.newPassword !== credentials.newPasswordConfirm" class="validation-message error">Passwords must match</div>
        </div>
        <div class="buttons">
          <b-spinner v-if="changingPassword" class="spinner"></b-spinner>
          <div v-if="!changingPassword">
            <b-button
            class="cancel"
            v-on:click="showDefaultWorkflow()">Cancel</b-button>
            <b-button
            class="submit"
            v-on:click="changePassword()"
            v-bind:disabled="!this.newPasswordValid || !credentials.currentPassword || !credentials.newPassword  || !credentials.newPasswordConfirm || credentials.newPassword !== credentials.newPasswordConfirm">Submit</b-button>
          </div>
        </div>
      </form>
    </div>
	</div>
</template>

<script>
import Authentication from "@/services/authentication";
import AppConfig from "../../../../resources/AppConfig.js";

export default {
  name: "ChangePasswordForm",
  props: {
      showDefaultWorkflow: Function,
      passwordChangeSuccess: Function,
      passwordChangeError: Function
  },
  data() {
    return {
      changingPassword: undefined,
      credentials: {},
      myclass: [],
      userGroups: [],
      newPasswordValid: false,
      passwordValidationRegex: AppConfig.passwordValidationRegex,
      passwordValidationInstructions: AppConfig.passwordValidationInstructions
    }
  },
  methods: {
      validatePassword() {
        this.newPasswordValid = this.passwordValidationRegex.test(this.credentials.newPassword);
      },
      changePassword() {
        if (!this.newPasswordValid || !this.credentials.currentPassword || !this.credentials.newPassword  || !this.credentials.newPasswordConfirm || this.credentials.newPassword !== this.credentials.newPasswordConfirm) {
          this.passwordChangeError({message: 'Please enter your current password, new password and confirm new password.'});
          return;
        }

        this.changingPassword = true;

        Authentication.getCurrentUser()
          .then(user => {
            const credentials = this.credentials;
            return Authentication.changeUserPassword(user, credentials.currentPassword, credentials.newPassword);
          })
          .then(this.passwordChangeSuccess)
          .catch(err => {
            this.changingPassword = undefined;
            this.passwordChangeError(err);
          });
      }
  }
};
</script>

<style lang="scss" scoped>
.change-password-container{
  form{
    .form-control-container{
      .validation-message{
        margin: 20px 0;

        &.error {
          color: #800000;
        }
      }
    }

    .buttons{
      .spinner{
        height: 40px;
        width: 40px;
        font-size: 22px;
        color: #fbd850;
      }

      button {
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
